import { FilespaceExtended } from 'fs-api-client';
import * as React from 'react';

export function renderFilespaceTypeSpan(filespace: FilespaceExtended): JSX.Element | null {
    switch (filespace.type) {
        case FilespaceExtended.TypeEnum.Sandbox:
            return <span className="warning">Sandbox</span>;
        case FilespaceExtended.TypeEnum.Unlimited:
            return <span className="active">Unlimited</span>;
        case FilespaceExtended.TypeEnum.V4beta:
            return <span className="warning">V4 Beta</span>;
        default:
            return null;
    }
}

export function renderFilespaceTypeList(filespace: FilespaceExtended): JSX.Element | null {
    switch (filespace.type) {
        case FilespaceExtended.TypeEnum.Sandbox:
            return <li className="warning">Sandbox</li>;
        case FilespaceExtended.TypeEnum.Unlimited:
            return <li className="active">Unlimited</li>;
        case FilespaceExtended.TypeEnum.V4beta:
            return <li className="warning">V4 Beta</li>;
        default:
            return null;
    }
}


// WEBPACK FOOTER //
// ./src/backoffice/components/common/Filespace.tsx